import type { ReactNode } from 'react';
import { env } from '@/lib/env';
import { ThemeToggle } from '@/components/common/theme-toggle';

interface AuthLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/** Centred card used by every unauthenticated page. */
export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-muted/30">
      <div className="flex justify-end p-4">
        <ThemeToggle />
      </div>

      <div className="flex flex-1 items-center justify-center px-4 pb-16">
        <div className="w-full max-w-sm">
          <div className="mb-6 flex flex-col items-center gap-2 text-center">
            {/* Not decorative here: on a bare sign-in page the mark is the
                only thing telling somebody whose system they are signing into,
                so it carries the company name rather than being hidden. */}
            <img
              src="/kiobytes-logo.png"
              alt={env.VITE_APP_NAME}
              className="size-12 object-contain"
            />
            <span className="text-lg font-semibold tracking-tight">{env.VITE_APP_NAME}</span>
          </div>

          <div className="rounded-xl border bg-card p-6 shadow-sm">
            <div className="mb-5 space-y-1">
              <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
              {description && <p className="text-sm text-muted-foreground">{description}</p>}
            </div>

            {children}
          </div>

          {footer && <div className="mt-4 text-center text-sm">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
